__turbopack_context__.v({
  "button": "bottom-bar-module__DEUiIa__button",
  "wrapper": "bottom-bar-module__DEUiIa__wrapper",
});
